import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteWorkspaceSecret } from '@/lib/api/generated/api';

import { toSecretError } from '../errors';
import { secretKeys } from '../queryKeys';

/**
 * Remove one entry outright.
 *
 * A hard delete with no history: the service keeps no previous value, so there
 * is nothing to undo to. The confirmation in front of this is what makes that
 * survivable, which is why it names the key rather than asking "are you sure?".
 */
export function useDeleteWorkspaceSecret(workspaceId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (key: string): Promise<void> => {
      const response = await deleteWorkspaceSecret(workspaceId, key);
      if (response.status === 204) return;
      throw toSecretError(response.status, response.data);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: secretKeys.all(workspaceId),
      });
    },
  });
}
